import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: [ './tooltip.component.scss' ]
})
export class TooltipComponent {

  @Input() static: boolean = false;
  keepVisible: boolean = false;

  onMouseEnter() {
    if (this.static) {
      this.keepVisible = true;
    }
  }
}
